var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Machine, assign } from 'xstate';
var trusteeMachine = Machine({
    id: 'trustee',
    initial: 'preview',
    context: {
        loading: false,
        complete: false,
        trustee: {
            schemeRoleId: '',
            title: '',
            firstName: '',
            lastName: '',
            trusteeType: '',
            isProfessionalTrustee: false,
            address: {
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                postTown: '',
                postcode: '',
                county: '',
            },
            telephoneNumber: '',
            emailAddress: '',
        },
        remove: null,
    },
    states: {
        preview: {
            id: 'preview',
            on: {
                EDIT_TRUSTEE: 'edit.trustee.name',
                EDIT_ORG: 'edit.company.address',
                EDIT_CONTACTS: 'edit.contact.details',
                REMOVE: 'remove',
                COMPLETE: {
                    actions: assign(function (_, event) { return ({
                        complete: event.value,
                    }); }),
                },
            },
        },
        edit: {
            id: 'edit',
            initial: 'trustee',
            states: {
                trustee: {
                    initial: 'name',
                    states: {
                        name: {
                            id: 'name',
                            on: {
                                NEXT: {
                                    target: 'kind',
                                    actions: assign(function (context, event) { return ({
                                        trustee: __assign(__assign({}, context.trustee), event.values),
                                    }); }),
                                },
                                CANCEL: '#preview',
                                REMOVE: '#remove',
                            },
                        },
                        kind: {
                            on: {
                                SAVE: {
                                    target: 'save',
                                    actions: assign(function (context, event) { return ({
                                        loading: true,
                                        trustee: __assign(__assign({}, context.trustee), event.values),
                                    }); }),
                                },
                                BACK: 'name',
                                CANCEL: '#preview',
                                REMOVE: '#remove',
                            },
                        },
                        save: saveTrustee('onDetailsSave', 'kind'),
                    },
                },
                company: {
                    initial: 'address',
                    states: {
                        address: {
                            id: 'address',
                            on: {
                                SAVE: {
                                    target: 'save',
                                    actions: assign(function (context, event) { return ({
                                        loading: true,
                                        trustee: __assign(__assign({}, context.trustee), { address: event.address }),
                                    }); }),
                                },
                                CANCEL: '#preview',
                                REMOVE: '#remove',
                            },
                        },
                        save: saveTrustee('onAddressSave', 'address'),
                    },
                },
                contact: {
                    initial: 'details',
                    states: {
                        details: {
                            on: {
                                SAVE: {
                                    target: 'save',
                                    actions: assign(function (context, event) { return ({
                                        loading: true,
                                        trustee: __assign(__assign({}, context.trustee), event.values),
                                    }); }),
                                },
                                CANCEL: '#preview',
                                REMOVE: '#remove',
                            },
                        },
                        save: saveTrustee('onContactSave', 'details'),
                    },
                },
            },
        },
        remove: {
            id: 'remove',
            initial: 'reason',
            states: {
                reason: {
                    on: {
                        SELECT: {
                            target: 'confirm',
                            actions: assign(function (_, event) {
                                return {
                                    remove: event.values,
                                };
                            }),
                        },
                        EDIT_TRUSTEE: '#edit.trustee.name',
                        CANCEL: '#preview',
                    },
                },
                confirm: {
                    on: {
                        EDIT_TRUSTEE: '#edit.trustee.name',
                        BACK: 'reason',
                        CANCEL: '#preview',
                        DELETE: 'deleted',
                    },
                },
                deleted: {
                    type: 'final',
                },
            },
        },
    },
});
function saveTrustee(onSaveFunctionName, targetOnError) {
    if (!onSaveFunctionName) {
        throw Error('saveTrustee function doesn`t have a prop name');
    }
    return {
        invoke: {
            id: onSaveFunctionName,
            src: onSaveFunctionName,
            onDone: {
                target: '#preview',
                actions: assign({
                    loading: false,
                }),
            },
            onError: {
                target: targetOnError,
                actions: assign({
                    loading: false,
                }),
            },
        },
    };
}
export default trusteeMachine;
//# sourceMappingURL=trusteeMachine.js.map